import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { EditRestaurantRequest } from '@/types/request/EditRestaurantRequest';
import { queryClient } from '@/main.tsx';

const useRestaurantEdit = () => {
  const client = supabaseClient;

  const mutationFn = async (request: EditRestaurantRequest) => {
    return editRestaurant(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['restaurants'] });
    },
  });
};

export default useRestaurantEdit;

async function editRestaurant(client: SupabaseClient, { id, ...rest }: EditRestaurantRequest): Promise<void> {
  const { data, error } = await client.from('restaurants').update(rest).eq('id', id).select('id').maybeSingle();

  if (error) throw new Error(error.message);
  if (!data) throw new Error('Failed to update Restaurant. Try with different values.');

  return;
}
